export class CsvService {
    public saveDataInCSV(data: Array<any>): string {
      if (data.length == 0) {
        return '';
      }
  
      let propertyNames = Object.keys(data[0]);
      let rowWithPropertyNames = propertyNames.join(',') + '\n';
  
      let csvContent = rowWithPropertyNames;
  
      let rows: string[] = [];
  
      data.forEach((item) => {
        let values: string[] = [];
  
        propertyNames.forEach((key) => {
          let val: any = item[key];
  
          if (val !== undefined && val !== null) {
            val = new String(val);
          } else {
            val = '';
          }
          values.push(val);
        });
        rows.push(values.join(','));
      });
      csvContent += rows.join('\n');
  
      return csvContent;
    }
  
    public importDataFromCSV(csvText: string): Array<any> {
      var propertyNames = csvText.slice(0, csvText.indexOf('\n')).split(',').map(element => element.trim());

      // remove linebreak inside quotes
      csvText = csvText.replace(/"(?:""|[^"])+"/g, function(x) { return x.replace(/[^\S\r\n]*[\n\r]\s*/g, '');});
      //csvText = csvText.replace(/[^\x00-\x7F]/g, "");

      // remove unicode characters
      csvText = csvText.replace(/[\u{0080}-\u{FFFF}]/gu,"");
  
      const dataRows = csvText.slice(csvText.indexOf('\n') + 1).split('\n');
      var lastItemIndex = propertyNames.length - 1;
      propertyNames[lastItemIndex] = propertyNames[lastItemIndex].replace(/(\r\n|\n|\r)/gm,"");
      let dataArray: any[] = [];
      let result;
      var failCount: number = 0;

      dataRows.forEach((row) => {
        

        try{
          //let values = row.split(/("[^"]*")|[^;]+/);
        let values = this.CSVtoArray(row);
        console.log('row',values);
        let obj: any = new Object();
        var newPropertyName: string;
  
        if (values)
        for (let index = 0; index < propertyNames.length; index++) {
          const propertyName: string = propertyNames[index];
          
          let val: any = values[index];
          if (val === '') {
            val = null;
          }

          //// TEMPORARY FIX ON MATCHING REQUIRED PROPERTY NAME
          /// TODO: MOVE PROCESSING OF OBJECT PROPERTIES TO CSV IMPORT COMPONENT
          if (propertyName.toUpperCase().includes('CONSIGNMENT')) {
            newPropertyName = 'CONSIGNMENT';
            obj[newPropertyName] = val;
          }
          ///////////////////////
  
          obj[propertyName] = val;
        }
        console.log('OBJ',obj);
        if (obj['CLIENT'] && obj['CONSIGNMENT']){
          dataArray.push(obj);
          console.log('saved row');
        } else {
          console.log('row failed');
          failCount++
        }

          
        }
        catch (e) {
          result = e.Message;
          console.log('error caught', result);
      }

      });


  
      return dataArray;
    }
  
    public importDataFromCSVByType(csvText: string, obj: any): Array<any> {
      const propertyNames = csvText.slice(0, csvText.indexOf('\n')).split(',');
      const dataRows = csvText.slice(csvText.indexOf('\n') + 1).split('\n');
  
      
      let dataArray: any[] = [];
      dataRows.forEach((row) => {
        let values = row.split(',');
  
        let dataObj: any = new Object();
        for (let index = 0; index < propertyNames.length; index++) {
          const propertyName: string = propertyNames[index];
  
          let value: any = values[index];
          if (value === '') {
            value = null;
          }
  
  
          if (typeof obj[propertyName] === 'undefined') {
            dataObj[propertyName] = undefined;
          } 
          else if (typeof obj[propertyName] === 'boolean') {
            dataObj[propertyName] = value.toLowerCase() === 'true';
          } 
          else if (typeof obj[propertyName] === 'number') {
            dataObj[propertyName] = Number(value);
          } 
          else if (typeof obj[propertyName] === 'string') {
            dataObj[propertyName] = value;
          }
          else if (typeof obj[propertyName] === 'object') {
            console.error("do no have algorithm to convert object");
          }
        }
  
        dataArray.push(dataObj);
      });
  
      return dataArray;
    }

    // Return array of string values, or NULL if CSV string not well formed.
CSVtoArray(text) {
  var re_valid = /^\s*(?:'[^'\\]*(?:\\[\S\s][^'\\]*)*'|"[^"\\]*(?:\\[\S\s][^"\\]*)*"|[^,'"\s\\]*(?:\s+[^,'"\s\\]+)*)\s*(?:,\s*(?:'[^'\\]*(?:\\[\S\s][^'\\]*)*'|"[^"\\]*(?:\\[\S\s][^"\\]*)*"|[^,'"\s\\]*(?:\s+[^,'"\s\\]+)*)\s*)*$/;
  var re_value = /(?!\s*$)\s*(?:'([^'\\]*(?:\\[\S\s][^'\\]*)*)'|"([^"\\]*(?:\\[\S\s][^"\\]*)*)"|([^,'"\s\\]*(?:\s+[^,'"\s\\]+)*))\s*(?:,|$)/g;
  // Return NULL if input string is not well formed CSV string.
  if (!re_valid.test(text)) return null;
  var a = [];                     // Initialize array to receive values.
  text.replace(re_value, // "Walk" the string using replace with callback.
      function(m0, m1, m2, m3) {
          // Remove backslash from \' in single quoted values.
          if      (m1 !== undefined) a.push(m1.replace(/\\'/g, "'"));
          // Remove backslash from \" in double quoted values.
          else if (m2 !== undefined) a.push(m2.replace(/\\"/g, '"'));
          else if (m3 !== undefined) a.push(m3);
          return ''; // Return empty string.
      });
  // Handle special case of empty last value.
  if (/,\s*$/.test(text)) a.push('');
  return a;
};

  }
  